import { z } from 'zod'

import ApiService from '../api.service'

import { zod } from '@acme/core'
import { updateEmpresaSchema } from './empresas'
import { SaldoHoras } from './saldoHoras'

export const updatePagamentoHorasSchema = zod.PagamentoHorasSchema.omit({
    updatedAt: true,
    createdAt: true,
})

const pagamentoHorasSchemaCompleto = updatePagamentoHorasSchema.extend({
    Funcionario: zod.FuncionarioSchema.deepPartial(),
    Empresa: updateEmpresaSchema.deepPartial(),
})

export const CreatePagamentoHorasSchema = updatePagamentoHorasSchema.omit({
    id: true,
})

export const CreateOrUpdatePagamentoHorasSchema =
    CreatePagamentoHorasSchema.extend({
        id: z.number().optional(),
    }).omit({
        competencia: true,
        funcionarioId: true,
        empresaId: true,
    })

export type PagamentoHoras = z.infer<typeof pagamentoHorasSchemaCompleto>
export type CreatePagamentoHoras = z.infer<typeof CreatePagamentoHorasSchema>
export type CreateOrUpdatePagamentoHoras = z.infer<
    typeof CreateOrUpdatePagamentoHorasSchema
>

const tudo = new ApiService<number[], void>('pagamento-horas/pagar-tudo')

const service = new ApiService<
    CreatePagamentoHoras,
    {
        limite: Partial<SaldoHoras>
        pagamento: PagamentoHoras
        saldo: SaldoHoras
    }
>('pagamento-horas')

export const pagamentoHoras = Object.assign(service, {
    tudo,
})
